import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <div className="luxury-container" style={{ padding: '60px 40px' }}>
        <button 
          onClick={() => navigate('/')}
          className="btn-secondary"
          style={{ marginBottom: '40px', display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ArrowLeft size={16} />
          Back to Home
        </button>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="heading-1" style={{ marginBottom: '16px' }}>Terms of Service</h1>
          <p className="body-small" style={{ color: 'var(--text-light)', marginBottom: '40px' }}>Last Updated: January 2025</p>

          <div className="body-regular" style={{ lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Acceptance of Terms</h2>
              <p style={{ marginBottom: '16px' }}>By accessing or using the services of Enliven Elite Tax Pro, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. Services Provided</h2>
              <p style={{ marginBottom: '16px' }}>Enliven Elite Tax Pro provides professional tax preparation services, including:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Individual tax return preparation (Form 1040)</li>
                <li style={{ marginBottom: '8px' }}>Self-employed and 1099 tax filing</li>
                <li style={{ marginBottom: '8px' }}>Small business and LLC tax returns</li>
                <li style={{ marginBottom: '8px' }}>Schedule C filings</li>
                <li style={{ marginBottom: '8px' }}>Prior-year and amended returns</li>
                <li style={{ marginBottom: '8px' }}>Tax consultation and planning</li>
                <li style={{ marginBottom: '8px' }}>IRS compliance support</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Professional Relationship</h2>
              <p style={{ marginBottom: '16px' }}>The relationship between Enliven Elite Tax Pro and clients is strictly professional. We are not affiliated with the IRS or any government agency. Our services do not constitute legal advice, and we recommend consulting an attorney for legal matters.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Client Responsibilities</h2>
              <p style={{ marginBottom: '16px' }}>As a client, you agree to:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Provide accurate and complete financial information</li>
                <li style={{ marginBottom: '8px' }}>Submit all necessary tax documents in a timely manner</li>
                <li style={{ marginBottom: '8px' }}>Review prepared tax returns carefully before filing</li>
                <li style={{ marginBottom: '8px' }}>Pay for services as agreed upon</li>
                <li style={{ marginBottom: '8px' }}>Comply with all applicable tax laws and regulations</li>
                <li style={{ marginBottom: '8px' }}>Notify us of any errors or omissions in your documents</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Fees and Payment</h2>
              <p style={{ marginBottom: '16px' }}>Service fees are determined based on the complexity of your tax situation and will be communicated before work begins. Payment is due upon completion of services unless otherwise agreed. Deferred payment options may be available for eligible clients.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>6. Accuracy and Liability</h2>
              <p style={{ marginBottom: '16px' }}>While we strive for exceptional accuracy, Enliven Elite Tax Pro is not liable for:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Errors resulting from incomplete or inaccurate information provided by clients</li>
                <li style={{ marginBottom: '8px' }}>Tax law changes after return filing</li>
                <li style={{ marginBottom: '8px' }}>IRS audits or penalties (unless due to our negligence)</li>
                <li style={{ marginBottom: '8px' }}>Indirect or consequential damages</li>
              </ul>
              <p style={{ marginBottom: '16px' }}>Our liability is limited to the fees paid for the specific service in question.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>7. Confidentiality</h2>
              <p style={{ marginBottom: '16px' }}>We maintain strict confidentiality of all client information in accordance with professional standards and applicable laws. Your financial information will not be shared without your consent, except as required by law.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>8. Appointment Cancellations</h2>
              <p style={{ marginBottom: '16px' }}>Appointments may be cancelled or rescheduled with at least 24 hours notice. Late cancellations or no-shows may be subject to a cancellation fee.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>9. Intellectual Property</h2>
              <p style={{ marginBottom: '16px' }}>All content on our website, including text, graphics, logos, and software, is the property of Enliven Elite Tax Pro and protected by copyright laws. Unauthorized use is prohibited.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>10. Termination of Services</h2>
              <p style={{ marginBottom: '16px' }}>Either party may terminate the professional relationship at any time. Upon termination, you are responsible for payment of services rendered to date. We will provide copies of your tax documents upon request.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>11. Dispute Resolution</h2>
              <p style={{ marginBottom: '16px' }}>Any disputes arising from these Terms of Service will be resolved through binding arbitration in accordance with applicable laws. You agree to waive your right to participate in class action lawsuits.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>12. Modifications to Terms</h2>
              <p style={{ marginBottom: '16px' }}>We reserve the right to modify these Terms of Service at any time. Changes will be effective upon posting to our website. Continued use of our services constitutes acceptance of modified terms.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>13. Contact Information</h2>
              <p style={{ marginBottom: '16px' }}>For questions about these Terms of Service, please contact us:</p>
              <p style={{ marginBottom: '8px' }}><strong>Enliven Elite Tax Pro</strong></p>
              <p style={{ marginBottom: '8px' }}>Phone: 800-426-0441</p>
              <p style={{ marginBottom: '8px' }}>Email: taxprep@enlivenelite.tax</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <p style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;